<template>
  <div class="section">
    <img v-if="page === 'subscription'" src="@/assets/img/premium/subscribed.png" />
    <img v-if="page === 'unsubscription'" src="@/assets/img/premium/unsubscribed.png" />
    <p v-if="page">{{ $t(`subscriptionCompleted.${page}.title`) }}</p>
    <div v-if="page" class="message">
      <div>{{ $t(`subscriptionCompleted.${page}.message1`) }}</div>
      <div>{{ $t(`subscriptionCompleted.${page}.message2`) }}</div>
      <div class="message-note" v-html="$t(`subscriptionCompleted.${page}.message3`)"></div>
    </div>
    <router-link class="button-design" :to="{ name: 'home' }">{{ $t("subscriptionCompleted.backToTop") }}</router-link>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  data() {
    return {
      page: "",
    };
  },
  created() {
    window.scrollTo(0, 0);

    if (this.$route.path.includes("/subscription")) {
      this.page = "subscription";
    } else if (this.$route.path.includes("/unsubscription")) {
      this.page = "unsubscription";
    }
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/style-common.scss";
.button-design {
  padding: 15px 50px;
  border-radius: var(--radius-rounded);
  font-weight: var(--font-weight-bold);
  border-style: none;
  color: var(--color-text-on-fixed-bg);
  text-decoration: none;
  background-color: var(--color-primary);

  margin: 30px 0;
  cursor: pointer;
  position: relative;
  @include hover-overlay;
}

.section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px 30px;
  color: var(--color-text-normal);

  img {
    max-width: 300px;
  }

  p {
    font-size: 1.5em;
    font-weight: var(--font-weight-bold);
  }

  .message {
    max-width: 600px;

    .message-note {
      margin-top: 1.5em;

      :deep(a) {
        color: var(--color-primary);
        text-decoration: underline;
      }
    }
  }
}
</style>
